export const isMobile = () : boolean | undefined => {
  try {
    return window.matchMedia("only screen and (max-width: 480px)").matches;
  } catch (e) {
    return undefined;
  }
};
